module.exports = __webpack_public_path__ + "img/x11.0efa1ccc.jpg";